import Head from 'next/head';
import type { NextPage } from 'next';
import React, { ReactNode } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { translations } from '@/locales';
import { consentValue, dataInspectorateValue, phoneValue, privacyValue, supportValue } from '@/constants';

import { Header } from '@/components/Header';
import { Footer } from '@/components/Footer';
import { PrivacyPolicyItem } from '@/components/PrivacyPolicyItem';

const PrivacyPolicy: NextPage = () => {
  const intl = useIntl();

  return (
    <main className="relative overflow-hidden text-black w-full">
      <Head>
        <title>{intl.formatMessage({ id: translations.pages.privacy.SEO.title })}</title>

        <link rel="icon" href="/favicon.ico" />
      </Head>
      <Header />

      <div className="w-full mx-auto px-4 max-w-xl  md:max-w-2xl lg:max-w-7xl">
        <div className="flex flex-col max-w-4xl mt-16 mb-16 md:mt-24 md:mb-52">
          <div className="text-3xl md:text-sectionTitle font-extrabold">
            <FormattedMessage id={translations.pages.privacy.title} />
          </div>

          <PrivacyPolicyItem section="dataProcessing" values={{ ...phoneValue, ...supportValue }} />

          <PrivacyPolicyItem
            section="dataCollection"
            values={{
              ...privacyValue,
              ul: (chunks: ReactNode) => <ul className="list-disc">{chunks}</ul>,
              li: (chunks: ReactNode) => <li className="ml-6 mt-3">{chunks}</li>
            }}
          />

          <PrivacyPolicyItem section="disclosure" />

          <PrivacyPolicyItem section="storageTime" />

          <PrivacyPolicyItem section="rights" values={{ ...supportValue, ...dataInspectorateValue, ...consentValue }} />

          <PrivacyPolicyItem section="complaints" values={{ ...dataInspectorateValue }} />

          <PrivacyPolicyItem section="changes" />
        </div>
      </div>

      <Footer />
    </main>
  );
};

export default PrivacyPolicy;
